<template>
  <v-content
    id="auth"
    :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'"
  >
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown
      }"
      :src="require(`@/assets/${src || 'clint-mckoy.jpg'}`)"
      gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
      min-height="100%"
    >
      <v-responsive
        :style="styles"
        min-height="100vh"
        class="d-flex align-center"
      >
        <router-view />
      </v-responsive>
    </v-img>
  </v-content>
</template>

<script>
  export default {
    name: 'AuthCoreView',

    data: () => ({
      srcs: {
        '/auth/login': 'register.jpg',
      },
    }),

    computed: {
      src () {
        return this.srcs[this.$route.path]
      },

      styles () {
        const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 2 : 1
        const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 2 : 1
        return {
          padding: `${paddingTop}% 0 ${paddingBottom}% 0`,
        }
      },
    },
  }
</script>
